module.exports = __webpack_public_path__ + "static/media/apexyellowsmall.800565fb.gif";